import axios from 'axios';
import { baseUrl } from '../../config';

const API_BASE = `${baseUrl}/festival-campaign`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
};

const getAuthHeadersMultipart = () => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  };
};

export const listCampaigns = async (params = {}) => {
  const response = await axios.get(`${API_BASE}/list`, {
    ...getAuthHeaders(),
    params,
  });
  return response.data;
};

export const createCampaign = async (data) => {
  const response = await axios.post(`${API_BASE}/create`, data, getAuthHeaders());
  return response.data;
};

export const readCampaign = async (id) => {
  const response = await axios.get(`${API_BASE}/read/${id}`, getAuthHeaders());
  return response.data;
};

export const updateCampaign = async (id, data) => {
  const response = await axios.patch(`${API_BASE}/update/${id}`, data, getAuthHeaders());
  return response.data;
};

export const deleteCampaign = async (id) => {
  const response = await axios.delete(`${API_BASE}/delete/${id}`, getAuthHeaders());
  return response.data;
};

export const uploadPoster = async (file) => {
  const formData = new FormData();
  formData.append('poster', file);
  const response = await axios.post(`${API_BASE}/upload-poster`, formData, getAuthHeadersMultipart());
  return response.data;
};

export const previewCampaign = async (id) => {
  const response = await axios.get(`${API_BASE}/preview/${id}`, getAuthHeaders());
  return response.data;
};

export const sendTest = async (campaign_id, phone_no) => {
  const response = await axios.post(`${API_BASE}/send-test`, { campaign_id, phone_no }, getAuthHeaders());
  return response.data;
};

// filters: { source, search, status, address_type, village, tehsil, district, occupation, skip_sent }
export const sendAll = async (id, filters = {}) => {
  const response = await axios.post(`${API_BASE}/send-all/${id}`, filters, getAuthHeaders());
  return response.data;
};

export const sendSelected = async (id, userIds) => {
  const response = await axios.post(`${API_BASE}/send-selected/${id}`, { userIds }, getAuthHeaders());
  return response.data;
};

// Get matching member count for given filters before sending
// filters: { source, search, campaign_id, skip_sent, ...memberFilters }
export const filterCount = async (filters = {}) => {
  const response = await axios.post(`${API_BASE}/filter-count`, filters, getAuthHeaders());
  return response.data;
};

// Paginated filtered member list for the Send-to-Selected table (members source)
export const listMembers = async (params = {}) => {
  const response = await axios.get(`${API_BASE}/members`, {
    ...getAuthHeaders(),
    params,
  });
  return response.data;
};

// Paginated list for any source (members, registration, purnima, visitor, exam_result, etc.)
export const listSourceMembers = async (params = {}) => {
  const response = await axios.get(`${API_BASE}/source-members`, {
    ...getAuthHeaders(),
    params,
  });
  return response.data;
};

// Send campaign to external contacts from an Excel file (.xlsx/.xls)
// Excel must have a "phone" column; optional: name, village, district, tehsil, address, occupation
export const sendExcel = async (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const token = localStorage.getItem('accessToken');
  const response = await axios.post(`${API_BASE}/send-excel/${id}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// ── Excel Contact Lists ──────────────────────────────────────────────────────

export const listExcelLists = async () => {
  const response = await axios.get(`${API_BASE}/excel-lists`, getAuthHeaders());
  return response.data;
};

export const uploadExcelList = async (name, file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('name', name);
  const response = await axios.post(`${API_BASE}/excel-lists/upload`, formData, getAuthHeadersMultipart());
  return response.data;
};

export const deleteExcelList = async (listId) => {
  const response = await axios.delete(`${API_BASE}/excel-lists/${listId}`, getAuthHeaders());
  return response.data;
};

export const getExcelListData = async (listId) => {
  const response = await axios.get(`${API_BASE}/excel-lists/${listId}/data`, getAuthHeaders());
  return response.data;
};

export const updateExcelListData = async (listId, headers, rows) => {
  const response = await axios.put(`${API_BASE}/excel-lists/${listId}/data`, { headers, rows }, getAuthHeaders());
  return response.data;
};

export const downloadExcelList = async (listId, name) => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${API_BASE}/excel-lists/${listId}/download`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob',
  });
  const url = URL.createObjectURL(new Blob([response.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${name || `excel_list_${listId}`}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
};

// payment_filter: 'all' | 'unpaid_only' | 'paid_only'
// skip_sent: boolean — skip phones already successfully sent this campaign
export const sendFromList = async (campaignId, listId, paymentFilter = 'all', skipSent = false) => {
  const response = await axios.post(
    `${API_BASE}/send-from-list/${campaignId}`,
    { list_id: listId, payment_filter: paymentFilter, skip_sent: skipSent },
    getAuthHeaders()
  );
  return response.data;
};

// Preview: how many contacts will actually be sent after applying filters
export const getListFilterCount = async (campaignId, listId, paymentFilter = 'all', skipSent = false) => {
  const response = await axios.post(
    `${API_BASE}/send-from-list/${campaignId}/count`,
    { list_id: listId, payment_filter: paymentFilter, skip_sent: skipSent },
    getAuthHeaders()
  );
  return response.data;
};
